/**
 * TODO
 * WIP
 */
import * as React from 'react';
import { PropsWithChildren } from 'react';

import { css, cx } from '@emotion/css';
import { Select, SelectProps, Theme } from '@mui/material';

import { useStyles } from '@/hooks/useStyles';
import { AtomProps, StyleClasses } from '@/uiKit/atoms/utils/AtomTypes.ts';

export type BaseDropDownSelectProps = PropsWithChildren<{
  value: string | undefined;
  fullWidth?: boolean;
  onChange?: SelectProps['onChange'];
  onBlur?: SelectProps['onBlur'];
  onFocus?: SelectProps['onFocus'];
  disabled?: boolean;
}>;

export type DropDownSelectClasses = StyleClasses<keyof SelectProps['classes']>;

export type DropDownSelectProps = AtomProps<
  BaseDropDownSelectProps,
  DropDownSelectClasses
>;

/**
 * DropDownSelect is a functional React component that renders a customized dropdown list
 *
 */
export const DropDownSelect: React.FC<DropDownSelectProps> = ({
  className,
  ...props
}) => {
  const styles = useStyles(makeStyles);
  return <Select {...props} className={cx(styles.select, className)} />;
};

const makeStyles = (theme: Theme) => ({
  select: css`
    background-color: #f0f0f0;
    border: none;
    border-radius: 24px;
    .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    &:hover .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    & .MuiSelect-select {
      padding: ${theme.spacing(2)} ${theme.spacing(8)};
    }
  `,
});
